import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';

@Component({
  selector: 'app-paginator',
  templateUrl: './paginator.component.html',
  styleUrls: ['./paginator.component.scss']
})
export class PaginatorComponent implements OnInit, OnChanges {

  @Input() pagesNumberArray: number[]
  @Input() currentPage: number
  @Input() pageCount: number = 10
  @Input() prevPage: number = 0
  @Input() nextPage: number = 0

  @Output() page = new EventEmitter<{pageNumber: number; pageSize: number} | undefined>()

  firstPages: number[]
  lastPages: number[]
  changeFirstPageRange: boolean = true

  pageDividend: number
  hasOverlapped: boolean = false

  constructor() { }

  ngOnInit(): void {
    this.calculatePageNumberRanges()
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['currentPage']?.previousValue) {
      this.calculatePageNumberRanges()
    }
  }

  calculatePageNumberRanges() {

    if (this.pagesNumberArray.length <= this.pageCount) {
      this.firstPages = this.pagesNumberArray
      this.lastPages = []
    }
    else {
      this.pageDividend = this.pageCount%2 === 0 ? this.pageCount/2 : (this.pageCount+1)/2

      let tempFirstPages = []

      if(this.changeFirstPageRange && !this.hasOverlapped) {
        this.firstPages = []
        tempFirstPages = this.pagesNumberArray.slice(this.currentPage - 1, (this.currentPage - 1) + this.pageDividend)
      }

      this.lastPages = this.pagesNumberArray.slice(this.pagesNumberArray.length-this.pageDividend, this.pagesNumberArray.length)

      if (this.currentPage === 1 || this.lastPages.indexOf(tempFirstPages[0]) > -1) {
        this.firstPages = this.pagesNumberArray.slice(this.currentPage - 1, (this.currentPage - 1) + this.pageDividend)
        this.hasOverlapped = false
      }
      else {
        for (const tempFirstPage of tempFirstPages) {
          if (this.lastPages.indexOf(tempFirstPage) === -1) {
            this.firstPages.push(tempFirstPage)
          } else {
            this.hasOverlapped = true
          }
        }
      }

      // if current page is in last pages reset first page range
      if (this.lastPages.indexOf(this.currentPage) > -1) {
        this.firstPages = this.pagesNumberArray.slice(0, this.pageDividend)
      }


    }

    // if (this.pagesNumberArray[this.pagesNumberArray.length-1])
  }

  changePageNumber(pageNumber :number) {
    this.changeFirstPageRange = this.firstPages.indexOf(pageNumber) === this.pageDividend-1 || this.firstPages.indexOf(pageNumber) === -1
    if (this.firstPages.indexOf(pageNumber) === -1) {
      this.hasOverlapped = false
    }

    this.page.emit({pageNumber, pageSize: 10})
  }

}
